<!-- <div class="row">
    <div class="col-12" style="margin-top: 100px;">
    </div>
</div> -->
<div class="container mt-3">
    <div class="row">
        <div class="col-12">
            <h5 class="dark mb-3 underline">
                Invoice
            </h5>
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th>Invoice Number</th>
                        <th>Name</th>
                        <th>Plan</th>
                        <th>Invoice Date</th>
                        <th>Due Date</th>
                        <th>Amount</th>
                        <th>Download</th>
                    </tr>
                </thead>
                <tbody *ngIf="invoiceData.length > 0">
                    <ng-container *ngFor="let data of invoiceData">
                        <tr>
                            <td>{{data.invoice_no}}</td>
                            <td>{{data.userData.name}}</td>
                            <td>{{(data.plan_data ? data.plan_data.plan_name : "")}}</td>
                            <td>{{data.invoice_date | date: 'MM-dd-YYYY'}}</td>
                            <td>{{data.due_date | date: 'MM-dd-YYYY'}}</td>
                            <td>{{shared.getIntValue(data.amount)}}</td>
                            <td><a href="javascript:void(0)" style="color: blue;"
                                    (click)="printInvoice(data.id)">Download</a></td>
                        </tr>
                    </ng-container>
                </tbody>
                <tbody *ngIf="invoiceData.length == 0">
                    <tr>
                        <td colspan="7" class="text-center">No data available</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>